<template>
    <el-dialog title="机构封面图" :visible.sync="centerDialogVisible" width="600px" :close-on-click-modal="false" class="shopLogo">
        <ShopLocalCropper :cropperOption="cropperOption" ref="localCropper" @setImage="_setImage" :uploadType="uploadType"></ShopLocalCropper>
        <div class="shopLogoBox">
            <p class="name">机构封面图</p>
            <div class="upload cover-image" @click="openDialog">
                <div class="avatar-uploader">
                    <div class="el-upload el-upload--text">
                        <img class="uploadImgIcon" :src="require('@/common/images/other/upload.png')" v-if="!img" alt="">
                        <img :src="img.furl +'?'+timestamp" alt="" class="uploadImg" v-else-if="img.furl && img.furl +'?' + timestamp">
                        <img :src="img" alt="" class="uploadImg" v-else>
                    </div>
                    <div class="el-upload__tip">
                        <div >建议尺寸1200*240px，JPG、PNG格式， 图片小于5M。</div>
                        <div>机构封面图作为背景使用，尽量使用简洁的图片。</div>
                    </div>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="comfirm">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import ShopLocalCropper from 'base/cropper/shopLocalCropper'
import {mapGetters, mapActions} from 'vuex'
import {uploadShopBgInfo} from 'api/accountApi'
export default {
    name: 'shopLogo',
    data() {
        return {
            centerDialogVisible: false,
            img: '',
            timestamp: new Date().getTime(),
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            cropperOption: {
                fixedNumber: [1200, 240], // 截图框的宽高比例
                enlarge: 1, // 图片根据截图框输出比例倍数
                autoCropWidth: 250, // 默认生成截图框宽度
                autoCropHeight: 50 // 默认生成截图框高度
            }
        }
    },
    props: ['data'],
    methods: {
        open() {
            this.centerDialogVisible = true
            this.img = this.data.mobshopbgurl
        },
        openDialog() {
            this.$refs.localCropper.openDialog()
        },
        _setImage(file) {
            this.timestamp = new Date().getTime()
            this.img = file
            console.log(this.img)
        },
        close() {
        },
        comfirm() {
            if (this.img) {
                if (this.img.furl || this.img) {
                    // delete this.img.type
                    // this.img = JSON.stringify(this.img)
                } else {
                    this.img = ''
                    return
                }
                let options = {
                    mobshopbgurl: this.img.furl ? this.img.furl : this.data.mobshopbgurl,
                    mobshopbgid: this.img.key  ? this.img.key : this.data.mobshopbgid
                }
                this.setLoading(true)
                console.log(this.img)
                uploadShopBgInfo({
                    data: options,
                    success: data => {
                        this.setLoading(false)
                        this.centerDialogVisible = false
                        this.$message.success('设置成功')
                        this.$emit('setCoverImg', options)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            } else {
                this.$message.error('请上传店铺logo')
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        ShopLocalCropper
    },
    watch: {
        'data': {
            handler(newV) {
                if (newV) {
                    this.img = newV.mobshopbgurl
                    console.log(this.img)
                }
            }
        },
        deep: true
    }
}
</script>
<style lang="scss">
    .shopLogo{
        .shopLogoBox{
            display: flex;
            // justify-content: space-between;
            .name {
                width: 120px;
            }
            .upload{
                .avatar-uploader{
                    // display: flex;
                    .el-upload{
                        width: 350px;
                        height: 50px;
                        margin-right: 10px;
                        background: #F5F7FA;
                        line-height: 50px;
                        text-align: center;
                        .uploadImgIcon{
                            width: 21px;
                            height: 21px;
                        }
                        .uploadImg{
                            width: 350px;
                            height: 50px;
                        }
                    }
                    .el-upload__tip{
                        color: #C0C4CC;
                        font-size: 14px;
                        flex: 1;
                        line-height: 20px;
                    }
                }
            }
        }
    }
</style>
